/**
 * split string on whitespace
 * @returns {Array} words
 */
export function splitStr(str) {
    return str.trim().split(/\s+/g);
}
//# sourceMappingURL=split-str.js.map